export const initRegionsMap = () => {
    const SVG_NS = 'http://www.w3.org/2000/svg';
    const DEFAULT_COUNTRY = "sk";

    const contactsFilterEls = document.querySelectorAll(".contacts-filter");
    const regionToggleEls = document.querySelectorAll('.region-toggle');

    if (!contactsFilterEls?.length || !regionToggleEls?.length) {
        return;
    }

    setActiveRegionToggle(DEFAULT_COUNTRY)
    setActiveRegionMap(DEFAULT_COUNTRY);
    clearAllActive(DEFAULT_COUNTRY);

    document.querySelectorAll('.contacts-map-result-title--back').forEach(el => el.addEventListener('click', (e) => {
        e.preventDefault();
        clearAllActive();
    }));

    regionToggleEls.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            const country = toggle.dataset.country;
            setActiveRegionToggle(country);
            setActiveRegionMap(country);
        });
    });

    contactsFilterEls.forEach((map) => {
        renderSvgPoints(map);
        const regionPaths = map.querySelectorAll('path');
        regionPaths.forEach((path) => {
            path.addEventListener('click', (e) => {
                const regionCode = e.target.dataset.regionCode;
                e.preventDefault();
                e.stopPropagation();
                setActiveRegion(regionCode);
            })
        })
    })

    document.querySelectorAll(".contacts-map-filter-link[data-office-id]").forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const officeId = link.dataset.officeId;
            setActiveOffice(officeId);
        });
    });

    document.querySelectorAll(".contacts-map-filter-link[data-region-code]").forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const regionCode = link.dataset.regionCode;
            setActiveRegion(regionCode);
        });
    });

    function setActiveRegionToggle(country) {
        clearAllActive(country);

        regionToggleEls.forEach((toggle) => {
            if (toggle.dataset.country === country) {
                toggle.classList.add('active');
            } else {
                toggle.classList.remove('active');
            }
        });
    }

    function setActiveRegionMap(country) {
        clearAllActive(country);

        contactsFilterEls.forEach((map) => {
            if (map.dataset.country === country) {
                map.classList.remove('d-none');
            } else {
                map.classList.add('d-none');
            }
        });
    }

    function setActiveRegion(regionCode) {
        const activeCountryCode = document.querySelector('.region-toggle.active')?.dataset.country;
        const activeRegionEl = document.querySelector(`.contacts-map-filter-link[data-region-code="${regionCode}"]`)
        clearAllActive(activeCountryCode);

        document.querySelector('.contacts-map-result-section--representatives .contacts-map-result-title--back')?.classList.remove('d-none');
        document.querySelector('.contacts-map-result-section--representatives .contacts-map-result-title--active-region-section')?.classList.remove('d-none');
        document.querySelector('.contacts-map-result-section--representatives .contacts-map-result-title--region-name').innerHTML = activeRegionEl?.innerHTML || '';
        document.querySelector(`path[data-region-code="${regionCode}"]`)?.classList.add('active');
        activeRegionEl?.classList.add('active');
        document.querySelector(`.contacts-map-result-section--offices`)?.classList.add('d-none');
        document.querySelectorAll(`.contacts-map-result-card--representative`)?.forEach(el => {
            if (!el.dataset.countryCodes.split(' ').includes(activeCountryCode)) {
                el.parentElement.classList.add('d-none');
                return;
            }

            if (el.dataset.regionCodes.split(' ').includes(regionCode)) {
                el.parentElement.classList.remove('d-none');
            } else {
                el.parentElement.classList.add('d-none');
            }
        });
    }

    function setActiveOffice(officeId) {
        const activeCountryCode = document.querySelector('.region-toggle.active')?.dataset.country;

        clearAllActive(activeCountryCode);
        document.querySelector('.contacts-map-result-section--offices .contacts-map-result-title--back')?.classList.remove('d-none');
        document.querySelector(`circle[data-office-id="${officeId}"]`)?.classList.add('active');
        document.querySelector(`.contacts-map-filter-link[data-office-id="${officeId}"]`)?.classList.add('active');
        document.querySelector(`.contacts-map-result-section--representatives`)?.classList.add('d-none');
        document.querySelectorAll(`.contacts-map-result-card--office`)?.forEach(el => {
            if (el.dataset.countryCode !== activeCountryCode) {
                el.parentElement.classList.add('d-none');
                return;
            }

            if (el.dataset.officeId === officeId.toString()) {
                el.parentElement.classList.remove('d-none');
            } else {
                el.parentElement.classList.add('d-none');
            }
        });

    }

    function clearAllActive(activeCountryCode) {
        activeCountryCode = activeCountryCode ?? document.querySelector('.region-toggle.active')?.dataset.country;
        document.querySelectorAll('.contacts-map-result-title--back').forEach(el => el.classList.add('d-none'));
        document.querySelectorAll('.contacts-map-result-title--active-region-section').forEach(el => el.classList.add('d-none'));
        document.querySelectorAll('.contacts-map-result-section').forEach(el => el.classList.remove('d-none'));
        document.querySelectorAll('.contacts-map-result-card').forEach(el => {
            if (el.classList.contains('contacts-map-result-card--office') && el.dataset.countryCode !== activeCountryCode ||
                el.classList.contains('contacts-map-result-card--representative') && !el.dataset.countryCodes.split(' ').includes(activeCountryCode)) {
                el.parentElement.classList.add('d-none');
                return;
            }

            el.parentElement.classList.remove('d-none')
        });
        document.querySelectorAll('.contacts-filter path').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.contacts-filter .region-map--marker').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.contacts-filter .contacts-map-filter-link').forEach(el => el.classList.remove('active'));
    }

    function renderSvgPoints(container) {
        const svg = container.querySelector('svg');
        if (!svg) return;

        // načti data-points
        let pts = [];
        try {
            pts = JSON.parse(container.dataset.points || '[]');
        } catch (e) {
            pts = [];
        }
        if (!Array.isArray(pts) || pts.length === 0) return;

        // přečti viewBox
        const vbRaw = (svg.getAttribute('viewBox') || '').trim().split(/\s+/).map(parseFloat);
        if (vbRaw.length !== 4 || vbRaw.some(isNaN)) {
            console.warn('[svgPoint] SVG nemá validní viewBox – nelze spočítat pozice bodů.');
            return;
        }
        const [minX, minY, vbW, vbH] = vbRaw;

        // odstraň staré body (pokud existují)
        let layer = svg.querySelector('g[data-layer="points"]');
        if (layer) layer.remove();
        layer = document.createElementNS(SVG_NS, 'g');
        layer.setAttribute('data-layer', 'points');
        svg.appendChild(layer);

        // velikost tečky relativně k viewBoxu (1.6 % kratší strany)
        const r = Math.min(vbW, vbH) * 0.016;

        pts.forEach((p, i) => {
            const xp = Number(p.x), yp = Number(p.y);
            if (isNaN(xp) || isNaN(yp)) return;

            // z relativních 0..1 → absolutní souřadnice ve viewBoxu
            const cx = minX + xp * vbW;
            const cy = minY + yp * vbH;

            const g = document.createElementNS(SVG_NS, 'g');
            g.setAttribute('class', 'svgpoint');

            const dot = document.createElementNS(SVG_NS, 'circle');
            dot.setAttribute('cx', cx);
            dot.setAttribute('cy', cy);
            dot.setAttribute('r', r.toString());
            dot.classList.add('region-map--marker');
            dot.setAttribute('data-office-id', p.id);
            // zachovej tloušťku obrysu při scale (volitelné):
            dot.setAttribute('vector-effect', 'non-scaling-stroke');
            g.appendChild(dot);

            g.addEventListener('click', (e) => {
                setActiveOffice(p.id);
            });

            layer.appendChild(g);
        });
    }
}
